//基金机构 新建 step1
export const legalDataItem = [
  {
    label: "姓名",
    field: "personName",
    formtype: "",
    require: false,
    rules: [
      {
        required: true,
        message: "请输入姓名",
        trigger: "blur",
      },
    ],
  },
  {
    label: "身份证号码",
    field: "certificateNo",
    formtype: "",
    require: false,
    rules: [
      {
        required: true,
        message: "请输入身份证号码",
        trigger: "blur",
      },
    ],
  },
  {
    label: "邮箱",
    field: "email",
    formtype: "",
    require: false,
  },
  {
    label: "联系电话",
    field: "tel",
    formtype: "",
    require: false,
    rules: [
      {
        required: true,
        message: "请输入联系电话",
        trigger: "blur",
      },
      {
        max: 11,
        type: "integer",
        message: "请输入正确的电话号码"
      },
    ],
  },
];
export const otherInfoItem = [
  [
    {
      name: "入驻申请书",
      oldFile: "",
    },
    {
      name: "公司章程或合伙协议",
      oldFile: "",
    },
    {
      name: "私募基金管理人营业执照",
      oldFile: "",
    },
    {
      name: "中国证券投资基金业协会登记佐证材料（提供管理人登记佐证材料）",
      oldFile: "",
    },
    {
      name: "管理人备案承诺书（已备案无须提供，新设必须提供）",
      oldFile: "",
    },
    {
      name: "其他材料",
      oldFile: "",
    },
  ],
  [
    {
      name: "入驻申请书",
      oldFile: "",
    },
    {
      name: "公司章程或合伙协议",
      oldFile: "",
    },
    {
      name: "私募基金管理人营业执照",
      oldFile: "",
    },
    {
      name: "中国证券投资基金业协会登记佐证材料（提供管理人登记佐证材料）",
      oldFile: "",
    },
    {
      name: "管理人备案承诺书（已备案无须提供，新设必须提供）",
      oldFile: "",
    },
    {
      name: "第三方托管意向书",
      oldFile: "",
    },
    {
      name: "其他材料",
      oldFile: "",
    },
  ],
  [
    {
      name: "入驻申请书",
      oldFile: "",
    },
    {
      name: "公司章程或合伙协议",
      oldFile: "",
    },
    {
      name: "佐证材料（主体公司代缴个税佐证材料，或主体公司缴纳社保佐证材料，或主体公司劳动合同，或主体公司关联方佐证材料， 或湖南湘江新区财政局（金融办）和长沙高新区科技金融服务中心认可的其他佐证材料）",
      oldFile: "",
    },
    {
      name: "主体公司关于同意设立持股平台的股东会决议",
      oldFile: "",
    },
    {
      name: "被纳入重点上市后备企业名单、新三板挂牌企业或上市公司佐证材料",
      oldFile: "",
    },
    {
      name: "主体公司商事变更登记承诺书",
      oldFile: "",
    },
    {
      name: "其他材料",
      oldFile: "",
    },

  ],
  [
    {
      name: "入驻申请书",
      oldFile: "",
    },
    {
      name: "公司章程或合伙协议",
      oldFile: "",
    },
    {
      name: "已缴出资额佐证材料",
      oldFile: "",
    },
    {
      name: "出资人备案承诺书",
      oldFile: "",
    },
    {
      name: "其他材料（至少三年。。）",
      oldFile: "",
    },
  ],
];

export const otherInfoItemManage = [
  {
    id: 0,
    name: "入驻申请书",
    oldFile: "",
    newFile: "",
  },
  {
    id: 1,
    name: "公司章程或合伙协议",
    oldFile: "",
    newFile: "",
  },
  {
    id: 2,
    name: "展业计划书/商业计划书（已登记无须提供）",
    oldFile: "",
    newFile: "",
    title: "已登记无须提供",
  },
  {
    id: 3,
    name: "私募基金管理人股权架构合理性说明（如设置超过三层需要提供、已登记无须提供）",
    oldFile: "",
    newFile: "",
  },
  {
    id: 15,
    name: "其他材料",
    oldFile: "",
    newFile: "",
  },
];

export const otherInfoItem2 = [
  {
    id: 0,
    name: "入驻申请书",
    oldFile: "",
    newFile: "",
  },
  {
    id: 1,
    name: "公司章程或合伙协议",
    oldFile: "",
    newFile: "",
  },
  {
    id: 2,
    name: "展业计划书/商业计划书（已登记无须提供）",
    oldFile: "",
    newFile: "",
    title: "已登记无须提供",
  },
  {
    id: 3,
    name: "私募基金管理人股权架构合理性说明（如设置超过三层需要提供、已登记无须提供）",
    oldFile: "",
    newFile: "",
  },
  {
    id: 4,
    name: "私募基金管理人营业执照",
    oldFile: "",
    newFile: "",
  },
  {
    id: 5,
    name: "中国证券投资基金业协会登记佐证材料（提供管理人登记佐证材料）",
    oldFile: "",
    newFile: "",
  },
  {
    id: 6,
    name: "管理人备案承诺书（已备案无须提供，新设必须提供）",
    oldFile: "",
    newFile: "",
  },
  {
    id: 7,
    name: "第三方托管意向书",
    oldFile: "",
    newFile: "",
  },
  {
    id: 8,
    name: "佐证材料（主体公司代缴个税佐证材料，或主体公司缴纳社保佐证材料，或主体公司劳动合同，或主体公司关联方佐证材料， 或湖南湘江新区财政局（金融办）和长沙高新区科技金融服务中心认可的其他佐证材料）",
    oldFile: "",
    newFile: "",
  },
  {
    id: 9,
    name: "主体公司关于同意设立持股平台的股东会决议",
    oldFile: "",
    newFile: "",
  },
  {
    id: 10,
    name: "被纳入重点上市后备企业名单、新三板挂牌企业或上市公司佐证材料",
    oldFile: "",
    newFile: "",
  },
  {
    id: 11,
    name: "主体公司商事变更登记承诺书",
    oldFile: "",
    newFile: "",
  },
  {
    id: 12,
    name: "已缴出资额佐证材料",
    oldFile: "",
    newFile: "",
  },
  {
    id: 13,
    name: "出资人备案承诺书",
    oldFile: "",
    newFile: "",
  },
  {
    id: 14,
    name: "其他材料",
    oldFile: "",
    newFile: "",
  },
  {
    id: 15,
    name: "其他材料",
    oldFile: "",
    newFile: "",
  },
];
